import { render, staticRenderFns } from "./MyHero.vue?vue&type=template&id=a812730c&"
import script from "./MyHero.vue?vue&type=script&lang=ts&"
export * from "./MyHero.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports